/** i18n key of the status column header (must resolve to a string). */
export const SERVICES_STATUS_HEADER_KEY =
  "partners.services.table.statusHeader";

/** i18n key of a status value label (active / inactive). */
export const servicesStatusValueKey = (status: string): string =>
  `partners.services.table.status.${status}`;
